import { Stack, Typography } from "@mui/material";
import { CustomTable } from "../../../shared";
import { createColumnHelper } from "@tanstack/react-table";
import { formatWeightWithUnits, parseFormattedWeight } from "../../../utils";
import React from "react";

export const RecipeWeight = ({ data, globalData }) => {
  const columnHelper = createColumnHelper(data);
  const columns = [
    columnHelper.accessor("base_unit_qty", {
      header: () => "Base Qty",
      cell: ({ row }) => {
        const value = formatWeightWithUnits(
          row?.original?.base_unit_qty,
          row?.original?.base_unit_symbol,
          globalData?.all_Units
        );
        const { qty } = parseFormattedWeight(value);
        return <Stack direction="row">{qty}</Stack>;
      },
    }),
    columnHelper.accessor("base_unit_symbol", {
      header: () => "Base Unit",
      cell: ({ row }) => {
        const value = formatWeightWithUnits(
          row?.original?.base_unit_qty,
          row?.original?.base_unit_symbol,
          globalData?.all_Units
        );
        const { unit } = parseFormattedWeight(value);
        return <Stack direction="row">{unit}</Stack>;
      },
    }),
    columnHelper.accessor("id", {
      header: () => "=",
      cell: (info) => "=",
    }),
    columnHelper.accessor("alt_unit_qty", {
      header: () => "Alternative Qty",
    }),
    columnHelper.accessor("alt_unit_symbol", {
      header: () => "Alternative Unit",
    }),
  ];
  return (
    <Stack>
      {data.length ? (
        <React.Fragment>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            pb="16px"
            pt="8px"
            height="46px"
            borderBottom={1}
            borderColor="divider"
          >
            <Typography
              variant="h6"
              fontWeight={600}
              lineHeight="19px"
              minWidth="160px"
            >
              Alternate UoM
            </Typography>
          </Stack>
          <CustomTable
            defaultData={data}
            columns={columns}
            isPagination={false}
            isTableHeader={false}
            hideEmptyContent={true}
            showSearchBar={false}
            enableTableContainerPaddingBottom
          />
        </React.Fragment>
      ) : null}
    </Stack>
  );
};
